import { createBrowserRouter } from "react-router-dom";
import DefaultLayout from "../layout/DefaultLayout";
import Home from "../pages/Home";
import CreateWorkflow from "../pages/CreateWorkflow";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/create-workflow", element: <CreateWorkflow /> },
    ],
  },
]);

export default router;
